module.exports = __webpack_public_path__ + "fonts/SFUIText-Light.1e343048.ttf";